import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { ThemeProvider } from "@mui/material";
import { theme } from "./theme/theme";
import { RouterProvider } from "react-router-dom";
import router from "./router";
import "./helpers/translations";
import { I18nextProvider } from "react-i18next";
import i18n from "./helpers/translations";
import { AppDataProvider } from "./context/AppDataProvider";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <AppDataProvider>
        <ThemeProvider theme={theme}>
          <RouterProvider router={router} />
        </ThemeProvider>
      </AppDataProvider>
    </I18nextProvider>
  </React.StrictMode>,
);
